/** What Xoala accepts for the credentials, checked before a save. */

export interface XoalaCredentialsInput {
  name: string;
  memberId: string;
  terminalId: string;
  partnerId: string;
  username: string;
  secretKey: string;
}

/** The i18n key (namespace `processors`) of the first problem, or null. */
export type XoalaValidationError =
  | 'nameRequired'
  | 'xoala.validation.memberIdRequired'
  | 'xoala.validation.terminalIdRequired'
  | 'xoala.validation.partnerIdRequired'
  | 'xoala.validation.usernameRequired'
  | 'xoala.validation.secretKeyRequired';

export function validateXoalaCredentials(input: XoalaCredentialsInput): XoalaValidationError | null {
  if (!input.name.trim()) return 'nameRequired';
  if (!/^\d+$/.test(input.memberId.trim())) return 'xoala.validation.memberIdRequired';
  if (!/^\d+$/.test(input.terminalId.trim())) return 'xoala.validation.terminalIdRequired';
  // Xoala refuses a partner id that is not numeric, 10 digits at most (30076).
  if (!/^\d{1,10}$/.test(input.partnerId.trim())) return 'xoala.validation.partnerIdRequired';
  if (!input.username.trim()) return 'xoala.validation.usernameRequired';
  if (!input.secretKey.trim()) return 'xoala.validation.secretKeyRequired';
  return null;
}
